import React, { useEffect, useState } from "react";
import { Phone, MessageCircle, Home } from "lucide-react";
import { Link } from "react-router-dom";
import { BRAND } from "../mock/mock";
import { api } from "../lib/api";
import { track } from "../lib/track";

const StickyActions = () => {
  const [brand, setBrand] = useState(BRAND);
  useEffect(() => { api.getBrand(BRAND).then((b) => b && setBrand({ ...BRAND, ...b })); }, []);
  const waNum = (brand.whatsapp || brand.phone || "").replace(/\D/g, "");
  return (
    <>
      {/* Desktop floating */}
      <div className="hidden md:flex fixed right-4 bottom-6 z-40 flex-col gap-2">
        <a
          href={`https://wa.me/${waNum}`}
          target="_blank"
          rel="noreferrer"
          onClick={() => track("whatsapp_tap", { target: waNum })}
          className="group flex items-center gap-2 bg-dl-teal hover:bg-teal-600 text-white rounded-full h-12 pr-4 pl-3 shadow-lg shadow-teal-500/30 transition"
        >
          <MessageCircle className="h-5 w-5" />
          <span className="text-sm font-semibold hidden group-hover:inline">Chat on WhatsApp</span>
        </a>
        <Link
          to="/home-sample-collection-ranchi"
          onClick={() => track("book_tap", { target: "/home-sample-collection-ranchi" })}
          className="group flex items-center gap-2 bg-dl-blue hover:bg-blue-700 text-white rounded-full h-12 pr-4 pl-3 shadow-lg shadow-blue-500/30 transition"
        >
          <Home className="h-5 w-5" />
          <span className="text-sm font-semibold hidden group-hover:inline">Book Home Collection</span>
        </Link>
      </div>

      {/* Mobile bottom bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-slate-200 grid grid-cols-3">
        <a
          href={`tel:${brand.phone}`}
          onClick={() => track("call_tap", { target: brand.phone })}
          className="flex flex-col items-center py-2.5 text-xs text-slate-700"
        >
          <Phone className="h-5 w-5 text-dl-blue mb-0.5" /> Call
        </a>
        <a
          href={`https://wa.me/${waNum}`}
          target="_blank"
          rel="noreferrer"
          onClick={() => track("whatsapp_tap", { target: waNum })}
          className="flex flex-col items-center py-2.5 text-xs text-white bg-dl-teal"
        >
          <MessageCircle className="h-5 w-5 mb-0.5" /> WhatsApp
        </a>
        <Link
          to="/book-test"
          onClick={() => track("book_tap", { target: "/book-test" })}
          className="flex flex-col items-center py-2.5 text-xs text-white bg-dl-blue"
        >
          <Home className="h-5 w-5 mb-0.5" /> Book Now
        </Link>
      </div>
    </>
  );
};

export default StickyActions;
